import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash/fp';
import { Box } from 'grommet';
import { FormDown } from 'grommet-icons';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import TextTitle from '../TextTitle';
import { motion } from 'framer-motion';
import useVisibilityRequirement from '../useVisibilityRequirement';

const DynamicAccordionItem = ({ blok, expanded, onExpand }) => {
  const {
    content,
    title,
    _uid,
    requiredPropertyBase,
    requiredPropertyType,
    requiredPropertyFindKey,
    requiredPropertyFindValue,
  } = blok;
  const isExpanded = Array.isArray(expanded)
    ? expanded.includes(_uid)
    : expanded === _uid;

  const { meetsRequirement } = useVisibilityRequirement(
    requiredPropertyBase,
    blok,
    requiredPropertyType,
    requiredPropertyFindKey,
    requiredPropertyFindValue
  );

  if (!meetsRequirement) {
    return null;
  }

  return (
    <Box overflow="hidden">
      <Box
        direction="row"
        onClick={() => onExpand(_uid)}
        focusIndicator={false}
        justify="between"
        pad={{ horizontal: 'xlarge', vertical: 'medium' }}
        border={{ side: 'top', size: 'small' }}
      >
        <TextTitle>{title}</TextTitle>
        <motion.div
          animate={{
            rotate: isExpanded ? '180deg' : '0deg',
          }}
          style={{
            transformOrigin: 'center center',
            display: 'flex',
            justifyItems: 'center',
          }}
        >
          <FormDown />
        </motion.div>
      </Box>
      <motion.div
        animate={{
          height: isExpanded ? 'auto' : 0,
          opacity: isExpanded ? 1 : 0,
        }}
        initial={{
          height: isExpanded ? 'auto' : 0,
          opacity: isExpanded ? 1 : 0,
        }}
        transition={{
          duration: 0.6,
        }}
        style={{
          overflow: 'hidden',
        }}
      >
        {content.map((item) => (
          <StoryblokComponent
            key={item.uuid}
            blok={item}
            {...omit('content', blok)}
          />
        ))}
      </motion.div>
    </Box>
  );
};

DynamicAccordionItem.propTypes = {
  blok: PropTypes.object.isRequired,
  expanded: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onExpand: PropTypes.func,
};

export default DynamicAccordionItem;
